/*
  HM Atlas Frontend
  API utility functions.
*/

import { axiosClient } from '@/core/services/http.service';

/* ---------------------------------------------------------- */

/**
 * Send a GET request to the specified URL.
 * @param url to api endpoint.
 * @returns Response from Axios client get().
 */
export const sendApiGetRequest = async (url) => {
  return await axiosClient.get(url);
};

/**
 * Send a POST request to the specified URL.
 * @param url to api endpoint.
 * @param data to be sent to the endpoint.
 * @returns Response from Axios client post().
 */
export const sendApiPostRequest = async (url, data) => {
  return await axiosClient.post(url, data);
};

/* ---------------------------------------------------------- */
// Modules.

export const getAllModules = async () => {
  const response = await sendApiGetRequest('/api/module');
  return (response.success ? response.body : []);
};

/* ---------------------------------------------------------- */
// Folders.

export const getAllFolders = async () => {
  const response = await sendApiGetRequest('/api/folder');
  return (response.success ? response.body : []);
};

/* ---------------------------------------------------------- */
// Entities.

export const getAllEntities = async () => {
  const response = await sendApiGetRequest('/api/entity');
  return (response.success ? response.body : []);
};

export const getEntity  = async (entityGuid) => {
  if (!entityGuid) return;
  const response = await sendApiGetRequest(`/api/entity/${entityGuid}`);
  return (response.success ? response.body : null);
};

/* ---------------------------------------------------------- */
// Fields.

export const getFields = async () => {
  const response = await sendApiGetRequest(`/api/field`);
  return (response.success ? response.body : []);
};

export const getEntityFields = async (entityGuid) => {
  if (!entityGuid) return [];
  const response = await sendApiGetRequest(`/api/entity/${entityGuid}/fields`);
  return (response.success ? response.body : []);
};

export const getField = async (fieldGuid) => {
  if (!fieldGuid) return;
  const response = await sendApiGetRequest(`/api/field/${fieldGuid}`);
  return (response.success ? response.body : null);
};

/* ---------------------------------------------------------- */
// Field Calculation.

export const verifyFieldCalculation = async (field) => {
  return await sendApiPostRequest(`api/FieldCalculation/Verify`, field);
};

export const getFieldCalculationAssistantOptions = async () => {
  return await sendApiGetRequest(`api/FieldCalculation/Assistant/options`);
};

export const askFieldCalculationAssistantQuery = async (queryData) => {
  return await sendApiPostRequest(`api/FieldCalculation/Assistant/query`, queryData);
};

export const getFieldCalculationFunctions = async (language, fieldDataType) => {
  return await sendApiGetRequest(`api/FieldCalculation/FunctionLibrary/${language}/${fieldDataType || ''}`);
};

/* ---------------------------------------------------------- */
// Extract Entity/Field/Data Response Error.
// In progress - to decypher comple/layered error responses.

export const extractErrorResponse = (response) => {
  const data = {};
  if (!response) return data;
  if (Array.isArray(response.item2) && response.item2.length) {
    data.item20 = response.item2[0];
    console.log(typeof data.item20.errorMessage);
    if ((data.item20.errorMessage || '').length) {
      // Extract response object that has intro message.
      let errorMessage = data.item20.errorMessage.replace(/^[^{]*/g, '').replace(/[^}]*$/g, '');
      const errorMessageData = JSON.parse(errorMessage);
      if (Array.isArray(errorMessageData.Errors))
      {
        data.error0 = errorMessageData.Errors[0];
        //console.log('data.error0', data.error0);
        // TBC.
      }
    }
  }

  return data;
};

/* ---------------------------------------------------------- */
